// extracted by css-extract-rspack-plugin
export default {"spaceXXSmall":"4px","size160":"160px","keyValue":"module-addon-common__keyValue___Kc9UA","moduleName":"module-addon-common__moduleName____kWvJ"};